/*
 * Copyright (c) Arbeidskracht Groep B.V. - all rights reserved
 */

export enum Route {
	ACCOUNT_EMAIL_CHANGE = '/wijzig-email',
	ACCOUNT_RECOVERY = '/reset-wachtwoord',
	CONFIRM_EMPLOYEE_REGISTRATION = '/registratie-bevestigen',
	FLEX_SERVICE_WORKER_REGISTRATION = '/account-migreren',
	LOGIN = '/',
	RESET_PASSWORD = '/wachtwoord-opnieuw-instellen'
}
